import { KBarAnimator, KBarPortal, KBarPositioner, KBarProvider, KBarSearch, } from "kbar";
import { observer } from "mobx-react-lite";
import * as React from "react";
import { $framework } from "../../../exports";
import { CommandBarActions } from "./CommandBarActions";
import { CommandBarResults } from "./CommandBarResults";
import { CommandBarStyle } from "./CommandBarStyle";
export const CommandBarProvider = observer(function CommandBarProvider({ children }) {
    return (React.createElement(KBarProvider, { actions: $framework.commands.actions },
        React.createElement(CommandBarStyle, null),
        React.createElement(CommandBarActions, null),
        React.createElement(KBarPortal, null,
            React.createElement(KBarPositioner, { className: "opendash-commandbar--positioner" },
                React.createElement(KBarAnimator, { className: "opendash-commandbar--animator" },
                    React.createElement(KBarSearch, { className: "opendash-commandbar--search" }),
                    React.createElement(CommandBarResults, null)))),
        children));
});
//# sourceMappingURL=CommandBarProvider.js.map